interface PdfLine {
  text: string
  size: number
  gap: number
  bold?: boolean
}

const lines: PdfLine[] = [
  { text: 'KEVIN L. BRANDENBURG', size: 19, gap: 22, bold: true },
  {
    text: 'EVP, Chief Procurement Officer & Head of Global Corporate Services',
    size: 10.5,
    gap: 15,
  },
  { text: 'Elizabethtown, Kentucky, United States  |  (937) 287-0680', size: 9.5, gap: 13 },
  {
    text: 'kevinleebrandenburg@gmail.com  |  www.linkedin.com/in/kevin-brandenburg-571132187',
    size: 9.5,
    gap: 26,
  },
  { text: 'EXECUTIVE BIOGRAPHY', size: 11.5, gap: 17, bold: true },
  {
    text: 'Seasoned global executive and strategic advisor with more than 39 years leading enterprise',
    size: 9.5,
    gap: 13,
  },
  {
    text: 'procurement, corporate real estate, workplace strategy, and corporate services across complex',
    size: 9.5,
    gap: 13,
  },
  {
    text: 'multinational organizations. Senior leadership roles with Parexel, Syneos Health, MetLife, and',
    size: 9.5,
    gap: 13,
  },
  {
    text: 'Kendle International, covering global portfolios, significant operating budgets, strategic sourcing,',
    size: 9.5,
    gap: 13,
  },
  { text: 'M&A activity, risk management, and enterprise transformation.', size: 9.5, gap: 24 },
  { text: 'SCALE OF RESPONSIBILITY', size: 11.5, gap: 17, bold: true },
  { text: 'Procurement spend exceeding $1 billion annually (Syneos Health)', size: 9.5, gap: 13 },
  { text: 'Real estate portfolio exceeding 18 million sq ft (MetLife)', size: 9.5, gap: 13 },
  { text: '$520M+ annual corporate real estate operating budget (MetLife)', size: 9.5, gap: 13 },
  { text: '21,000+ employees supported across 45+ countries (Parexel)', size: 9.5, gap: 13 },
  { text: '140+ global sites across 45 countries (Syneos Health)', size: 9.5, gap: 24 },
  { text: 'EXPERIENCE', size: 11.5, gap: 18, bold: true },
  { text: 'Green Cabbage - Executive Advisory Board', size: 10.5, gap: 13, bold: true },
  {
    text: 'Strategic counsel on growth, procurement strategy, market development, partnerships,',
    size: 9.5,
    gap: 12,
  },
  { text: 'client relationships, and emerging opportunities.', size: 9.5, gap: 19 },
  {
    text: 'Parexel - EVP, Chief Procurement Officer & Head of Global Corporate Services',
    size: 10.5,
    gap: 13,
    bold: true,
  },
  {
    text: 'Led global procurement exceeding $900M annual spend, a 1.2M sq ft international portfolio,',
    size: 9.5,
    gap: 12,
  },
  {
    text: 'global travel, business continuity, sustainability, and corporate services. Contributed $40M+',
    size: 9.5,
    gap: 12,
  },
  {
    text: 'in annual real estate operating-cost reductions and $30M+ in annual supplier savings.',
    size: 9.5,
    gap: 19,
  },
  {
    text: 'Syneos Health - EVP, Head of Corporate Real Estate and Global Procurement',
    size: 10.5,
    gap: 13,
    bold: true,
  },
  {
    text: 'Oversaw 140+ sites across 45 countries and 2.1M+ sq ft of real estate with procurement',
    size: 9.5,
    gap: 12,
  },
  {
    text: 'spend exceeding $1B annually. Led the non-labor synergy program after the 2017 INC Research',
    size: 9.5,
    gap: 12,
  },
  {
    text: '/ InVentiv Health merger, exceeding the three-year target with $40M+ in operating reductions.',
    size: 9.5,
    gap: 19,
  },
  {
    text: 'MetLife - VP, Head of Global Corporate Real Estate & Services',
    size: 10.5,
    gap: 13,
    bold: true,
  },
  {
    text: 'Governed an international portfolio exceeding 18M sq ft and a $520M+ annual operating budget.',
    size: 9.5,
    gap: 12,
  },
  {
    text: 'Senior advisor on strategic planning, global M&A, real estate investments, labor arbitrage, and',
    size: 9.5,
    gap: 12,
  },
  {
    text: 'portfolio optimization; contributed an estimated $110M in annual cost reduction.',
    size: 9.5,
    gap: 19,
  },
  {
    text: 'Kendle International - Senior Leadership, Corporate Real Estate & Procurement',
    size: 10.5,
    gap: 13,
    bold: true,
  },
  {
    text: 'Senior responsibility across corporate real estate, procurement, and corporate services.',
    size: 9.5,
    gap: 24,
  },
  { text: 'BOARD, RECOGNITION & EDUCATION', size: 11.5, gap: 17, bold: true },
  { text: 'Board of Directors, Edison Supply and Distribution (prior)', size: 9.5, gap: 13 },
  { text: 'Top 15 CPOs in Diversity - Diversity Magazine, 2023', size: 9.5, gap: 13 },
  { text: 'Master of Corporate Real Estate (MCR), CoreNet Global', size: 9.5, gap: 13 },
  {
    text: 'BA, Organizational Leadership, summa cum laude - Northern Kentucky University',
    size: 9.5,
    gap: 13,
  },
]

function escapeText(value: string): string {
  return value
    .replace(/\\/g, '\\\\')
    .replace(/\(/g, '\\(')
    .replace(/\)/g, '\\)')
    .replace(/[^\x20-\x7E]/g, '-')
}

function buildPdf(): string {
  let content = 'BT\n'
  let y = 756
  lines.forEach((line) => {
    content += `/${line.bold ? 'F2' : 'F1'} ${line.size} Tf\n`
    content += `1 0 0 1 54 ${y} Tm\n`
    content += `(${escapeText(line.text)}) Tj\n`
    y -= line.gap
  })
  content += 'ET'

  const objects = [
    '<< /Type /Catalog /Pages 2 0 R >>',
    '<< /Type /Pages /Kids [3 0 R] /Count 1 >>',
    '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 612 792] /Resources << /Font << /F1 5 0 R /F2 6 0 R >> >> /Contents 4 0 R >>',
    `<< /Length ${content.length} >>\nstream\n${content}\nendstream`,
    '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>',
    '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>',
  ]

  let pdf = '%PDF-1.4\n'
  const offsets: number[] = []
  objects.forEach((object, index) => {
    offsets.push(pdf.length)
    pdf += `${index + 1} 0 obj\n${object}\nendobj\n`
  })

  const xrefOffset = pdf.length
  pdf += `xref\n0 ${objects.length + 1}\n0000000000 65535 f \n`
  offsets.forEach((offset) => {
    pdf += `${String(offset).padStart(10, '0')} 00000 n \n`
  })
  pdf += `trailer\n<< /Size ${objects.length + 1} /Root 1 0 R >>\nstartxref\n${xrefOffset}\n%%EOF`

  return pdf
}

export function downloadResume(): void {
  const blob = new Blob([buildPdf()], { type: 'application/pdf' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = 'Kevin-L-Brandenburg-Executive-Bio.pdf'
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  window.setTimeout(() => URL.revokeObjectURL(url), 1000)
}
